import { BasePage } from '@/components/ui/base-page'

export function DigitalTransformationPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add DigitalTransformationPage specific content here */}
    </BasePage>
  )
}